//"use strict";


/* --------------------------
    Dependecies libs:
        jquery.js
        jquery.ui.js
        moment.js
--------------------------  */


import {store} from "../../redux/storeConfig/store";
import {utils_ui} from "../utils/utils_ui";
import {utils_log} from "../utils/utils_log";
import {cloneDeep} from "lodash";


export var dataUtils = {

    // addIsSelectedColumnToDataArray: (prmLstData, prmDefaultValue)=> {
    //
    // }

    // parseFontIcon: (prmIconStr)=>{
    //     let outVal = "";
    //
    //     let dicOldFontIcons = {
    //         "sticky-note-o": "sticky-note",
    //         "envelope-o": "envelope",
    //         "bell-o": "bell",
    //         "fa-question-circle-o": "question"
    //     };
    //
    //     if (!!prmIconStr){
    //         outVal = prmIconStr.substr(prmIconStr.indexOf("-") + 1);
    //
    //         let startIndex =prmIconStr?.indexOf(".")
    //         if(startIndex){
    //             outVal =  prmIconStr.substr(startIndex+1).replace(']',"")
    //         }
    //
    //         if (!!dicOldFontIcons[outVal]){
    //             outVal = dicOldFontIcons[outVal];
    //         }
    //     }
    //
    //     return outVal;
    // },

    getNumberDecimalPart: (prmNumber) => {
        let outVal = 0;
        let numStr = prmNumber.toString();

        if (numStr.includes('.')) {
            outVal = parseFloat(numStr.split('.')[1]);
        }

        return outVal
    },

    replaceFormatToMomentFormat: (prmFormat) => {
        let newFormat = prmFormat.replaceAll('dd', 'DD')

        return newFormat;
    },

    intersectTwoArrays: (prmArr1, prmArr2) => {
        let lstFiltered = prmArr1.filter(prmValue => prmArr2.includes(prmValue))
        return lstFiltered
    },

    diffTwoArrays: (prmArrMaster, prmArrSlave) => {
        let lstDifference = prmArrMaster.filter(prmValue => !prmArrSlave.includes(prmValue))
        return lstDifference
    },

    updatePageDataStoreOriginalData: (prmStateObj, prmResponseName, prmDataObj) => {
        //newOrigQueryState.originalData[action.responseName] = cloneDeep(newOrigQueryState.data[action.responseName])
        prmStateObj.originalData[prmResponseName] = cloneDeep(prmDataObj || {})

        return prmStateObj.originalData
    },

    isNumeric: (prmValue) => {
        let outVal = false

        if (prmValue != null
            && prmValue != undefined
            && prmValue != "") {
            outVal = !isNaN(prmValue.toString().replaceAll(',',''))
        }

        return outVal
    },
    parseLangKey: (prmLangKey, prmDefaultLangKey) => {
        let outVal = prmLangKey;
        if (prmLangKey != null && !!prmLangKey && prmLangKey.length > 0 && (prmLangKey.indexOf("@") > -1 || prmLangKey.indexOf("[") > -1)) {
            let startIndex = prmLangKey?.indexOf(".")
            if (startIndex) {
                outVal = prmLangKey.substr(startIndex + 1).replace(']', "")
            }

            if (!outVal) {
                outVal = "Title_UndefinedLangKey";
            }

        }
        // if(!isNaN(prmLangKey) && prmLangKey !=null){
        //     prmLangKey = prmLangKey.toString();
        // }

        if (outVal == null) {

            if (prmDefaultLangKey) {
                outVal = prmDefaultLangKey;
            }
            else {
                outVal = "Title_UndefinedLangKey"
            }
        }

        return outVal
    },
    getNewGuid: function () {

        var outVal = s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();

        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }

        return outVal;
    },

    getTrimmedValuesBetweenCurlyBraces: function (prmStr) {
        let lstOut =[]
        let lstValues = this.getValuesBetweenCurlyBraces(prmStr)

        for (const currValue of lstValues) {
            lstOut.push(currValue.trim())
        }

        return lstOut
    },
    sumByProperty: function (prmArr, prmSumPropertyName) {
        let outVal = 0;

        if (!!prmArr && Array.isArray(prmArr) && prmArr.length > 0) {
            for (let ind01 = 0; ind01 < prmArr.length; ind01++) {
                if (prmArr[ind01].hasOwnProperty(prmSumPropertyName)) {
                    outVal += prmArr[ind01][prmSumPropertyName] || 0;
                }
            }
        }

        return outVal;
    },
    getValuesBetweenCurlyBraces: function (prmStr) {
        const regex = /{([^}]+)}/g; // Regular expression to match text between curly brackets
        let result = [];
        let match;

        while ((match = regex.exec(prmStr)) !== null) {
            result.push(match[1]); // match[1] contains the value between the curly brackets
        }

        return result;
    },

    getActualValueOrDefault: function (prmObject, prmNestedPropertyStr, prmDefaultValue) {
        var outVal = prmDefaultValue;
        var currValue = dataUtils.getNestedJsonValue(prmObject, prmNestedPropertyStr);

        if (currValue != undefined) {
            outVal = currValue;
        }

        return outVal;
    },

    calcPercent: function (prmValue, prmDivider, prmNumDecimalPoints) {
        let outVal = null;

        if (prmValue != undefined && prmValue != null) {
            outVal = 0

            if (prmNumDecimalPoints == undefined || prmNumDecimalPoints == null) {
                prmNumDecimalPoints = 0;
            }

            if(!!prmDivider){
                outVal = ((prmValue / prmDivider) * 100).toFixed(prmNumDecimalPoints);
            }
        }

        return outVal
    },
    isDateValid: function (prmDate) {
        var isString = typeof prmDate == "string";
        var outVal = false;

        if (isString) {
            var isValidStrDate = false;

            var arrItems = prmDate.split("/");
            if (arrItems.length == 3) {
                isValidStrDate = true;
                for (var ind01 = 0; ind01 < arrItems.length; ind01++) {
                    if (arrItems[ind01].length == 0) {
                        isValidStrDate = false;
                        break;
                    }
                }

                if (isValidStrDate) {
                    var currDate = new Date(prmDate);

                    outVal = (currDate instanceof Date && !isNaN(currDate));
                }
            }
        }
        else {

            outVal = (prmDate instanceof Date && !isNaN(prmDate));
        }

        return outVal;
    },

    //getDateIfValid: function (prmDate) {
    //    var outVal = null;

    //    if (this.isDateValid(prmDate)) {
    //        outVal = new Date(prmDate);
    //    }

    //    return outVal;
    //},

    isConditionTrue: function (prmValueType, prmOperator, prmConditionValue, prmActualValue) {
        var isConditionTrue = false;
        var conditionValue = undefined;

        switch (prmValueType) {
            case 'string':
                conditionValue = prmConditionValue;
                break;
            case 'number':
                conditionValue = parseFloat(prmConditionValue);
                break;
            case 'date':
                //TO DO
                break;
            case 'boolean':
                conditionValue = (prmConditionValue.toLowerCase() == 'true');
                //parsedValue = (prmActionParameters.Value == 'true');
                break;
            default:
                conditionValue = prmConditionValue;
        }

        switch (prmOperator) {
            case "greater": //Greater
                if (prmActualValue > conditionValue) {
                    isConditionTrue = true;
                }
                break;

            case "less": //Less Than
                if (prmActualValue < conditionValue) {
                    isConditionTrue = true;
                }
                break;

            case "equals": //Equals

                if (prmActualValue == conditionValue) {
                    isConditionTrue = true;
                }
                break;

            case "notEquals": //Not Equals

                if (prmActualValue != conditionValue) {
                    isConditionTrue = true;
                }
                break;

            case "between": //Between
                //TODO: add value2 field to  handle it
                break;

            case "greaterOrEquals": //Greater or Equals
                if (prmActualValue >= conditionValue) {
                    isConditionTrue = true;
                }
                break;

            case "lessOrEquals": //Less or Equals
                if (prmActualValue <= conditionValue) {
                    isConditionTrue = true;
                }
                break;
        }

        return isConditionTrue;
    },
    convertValueToType: function (prmValue, prmDataType) {
        if (prmValue == undefined) {
            prmValue = "";
        }

        var strValue = prmValue.toString();
        var outVal = null;

        switch (prmDataType) {
            case 'null':
                outVal = null;
                break;

            case 'number':
                if (strValue == "") {
                    strValue = "0";
                }

                outVal = parseFloat(utils_ui.parseSystemValue(strValue));
                break;

            case 'string':
                outVal = utils_ui.parseSystemValue(strValue);
                break;

            case 'date':
                if (!!strValue) {
                    outVal = new Date(utils_ui.parseSystemValue(strValue));
                }
                break;

            case 'boolean':
            case 'bit':
                if (strValue == "") {
                    strValue = "false";
                }

                outVal = strValue === undefined || utils_ui.parseSystemValue(strValue).toString().toLowerCase() === "true";
                break;
        }

        return outVal;
    },

    addPaddingBeforeNumber: function (prmNumber, prmWidth, prmPaddingChar) {
        var outStr = "";
        var valueStr = "";

        if (prmNumber != null && prmNumber != undefined) {
            valueStr = prmNumber.toString();
        }

        var numPadding = prmWidth - valueStr.length;

        for (var ind01 = 0; ind01 < numPadding; ind01++) {
            outStr += prmPaddingChar;
        }

        outStr += valueStr;

        return outStr;
    },

    setCookie: function (cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires;
    },

    getCookie: function (cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },

    'getTimeStrFromDate': function (prmDate) {
        var outVal = "";

        if (!!prmDate) {
            outVal = prmDate.getHours() + ":" + prmDate.getMinutes();
        }

        return outVal;
    },

    convertValueToConcludedType: function (prmValue) {
        var outVal = null;

        if (typeof prmValue === 'number') {
            outVal = Number(prmValue);
        }
        else if (this.isDateValid(prmValue)) {
            outVal = this.convertValueToType(prmValue, "date");
        }
        else if (this.isBoolean(prmValue)) {
            outVal = this.convertValueToType(prmValue, "boolean");
        }
        else {
            outVal = prmValue;
        }

        return outVal;
    },

    // convertValueToType: function (prmValue, prmDataType) {
    //     if (prmValue == undefined) {
    //         prmValue = "";
    //     }

    //     var strValue = prmValue.toString();
    //     var outVal = null;

    //     switch (prmDataType) {
    //         case 'null':
    //             outVal = null;
    //             break;

    //         case 'number':
    //             if (strValue == "") {
    //                 strValue = "0";
    //             }

    //             outVal = parseFloat(APPLYOO.runtimeUtils.parseSystemValue(strValue));
    //             break;

    //         case 'string':
    //             outVal = APPLYOO.runtimeUtils.parseSystemValue(strValue);
    //             break;

    //         case 'date':
    //             outVal = new Date(APPLYOO.runtimeUtils.parseSystemValue(strValue));
    //             break;

    //         case 'boolean':
    //             if (strValue == "") {
    //                 strValue = "false";
    //             }

    //             outVal = strValue === undefined || APPLYOO.runtimeUtils.parseSystemValue(strValue).toString().toLowerCase() == "true";
    //             break;
    //     }

    //     return outVal;
    // },

    getLstFiltersByFilterObj: function (prmFilterObj) {

        var arrFilter = [];

        if (!!prmFilterObj) {
            for (var field in prmFilterObj) {
                if (!!prmFilterObj[field] && !!prmFilterObj[field].FieldValue) {
                    var filterObj = {
                        "FieldName": field,
                        "FieldValue": prmFilterObj[field].FieldValue,
                        "Operator": prmFilterObj[field].Operator
                    };
                    arrFilter.push(filterObj);
                }
            }
        }

        return arrFilter;
    },

    getUniqueValuesUngrouped: function (prmArray) {
        var currItem;
        var outArray = [];
        var endChars = "<end>";
        var currGroup = {};
        var groupNamesArray = [];

        if (!!prmArray) {
            currGroup = {
                groupName: "",
                isExpanded: true,
                groupItems: []
            };

            for (var ind01 = 0; ind01 < prmArray.length; ind01++) {
                currItem = prmArray[ind01];
                currGroup.groupItems.push(currItem);

                //outArray.push(currGroup);
                //groupNamesArray.push(currItemStrWithEndChars);

            }

            //for (var ind01 = 0; ind01 < outArray.length; ind01++) {
            //    outArray[ind01].groupName = outArray[ind01].groupName.substring(0, outArray[ind01].groupName.length - endChars.length);
            //}

            outArray.push(currGroup);
        }

        return outArray;
    },

    getGroupByRows: function (prmArray, prmPropertyName) {
        var currItem;
        var outArray = [];
        var endChars = "<end>";
        var currGroup = {};
        var groupNamesArray = [];

        if (!!prmArray) {
            for (var ind01 = 0; ind01 < prmArray.length; ind01++) {
                currItem = prmArray[ind01];

                if (currItem.hasOwnProperty(prmPropertyName)) {
                    var currItemStrWithEndChars = currItem[prmPropertyName] + endChars;

                    if (groupNamesArray.indexOf(currItemStrWithEndChars) == -1) {
                        currGroup = {
                            rowKey: currItemStrWithEndChars,
                            isExpanded: true,
                            lstRowItems: []
                        }

                        outArray.push(currGroup);
                        groupNamesArray.push(currItemStrWithEndChars);
                    }
                    else {
                        currGroup = outArray[dataUtils.indexOfInArrayByString(groupNamesArray, currItemStrWithEndChars)];
                    }

                    currGroup.lstRowItems.push(currItem);
                }
            }

            for (var ind01 = 0; ind01 < outArray.length; ind01++) {
                outArray[ind01].rowKey = outArray[ind01].rowKey.substring(0, outArray[ind01].rowKey.length - endChars.length);
            }
        }

        return outArray;
    },

    getDisplayTextByRepository: function (prmRepositoryObj, prmIDFieldKeyName, prmIDKeyValue, prmObjFieldNameStr) {
        var outObj = "";

        if (prmRepositoryObj != null && prmIDFieldKeyName != null, prmIDKeyValue != null, prmObjFieldNameStr != null) {
            var dicObj = dataUtils.convertArrayToDicObject(prmRepositoryObj, prmIDFieldKeyName);

            outObj = dataUtils.getDisplayTextByDicRepository(dicObj, prmIDKeyValue, prmObjFieldNameStr);
        }

        return outObj;
    },

    getDisplayTextByDicRepository: function (prmDicObj, prmIDKeyValue, prmObjFieldNameStr) {

        var outObj = "";

        if (prmDicObj != null && prmIDKeyValue != null && prmObjFieldNameStr != null) {
            if (prmDicObj.hasOwnProperty(prmIDKeyValue)) {
                var selectedObj = prmDicObj[prmIDKeyValue];

                if (selectedObj != null && selectedObj.hasOwnProperty(prmObjFieldNameStr)) {
                    var currValue = selectedObj[prmObjFieldNameStr];
                    if (currValue != null) {
                        outObj = currValue;
                    }

                }
            }
        }

        return outObj;




    },

    // setDataInCookie: function (prmObjNameStr, prmDataObj) {

    //     var dateNow = new Date();

    //     if ((!!prmObjNameStr && prmObjNameStr.length > 0)) {

    //         if (prmDataObj == undefined || Object.keys(prmDataObj).length == 0) {
    //             $.removeCookie(prmObjNameStr);
    //         }
    //         else {
    //             prmDataObj.lastSaveDT = dateNow;
    //             $.cookie(prmObjNameStr, prmDataObj, { expires: 2190, path: '/' });
    //         }

    //     }

    // },

    // getDataInCookie: function (prmObjNameStr) {

    //     var outVal = undefined;

    //     if (!!prmObjNameStr && prmObjNameStr.length > 0) {

    //         outVal = $.cookie(prmObjNameStr);
    //     }

    //     return outVal;

    // },



    getArrayItemIndex: function (prmArray, prmFieldName, prmFieldValue) {
        var outVal = -1;

        outVal = prmArray.map(function (prmItem) {
            return prmItem[prmFieldName];
        }).indexOf(prmFieldValue);

        return outVal;
    },

    getDistinctArrayItems: function (prmArray, prmKeyFieldName, prmDisplayFieldName, prmDicIgnoredValues, isStayInSameStructure) {
        //comment: return a new array with unique items as value/text object  - distinct by prmKeyFieldName field
        var arrOut = [];

        var dicUniqueItems = {};

        if (!!prmArray) {
            let itemObj = {};

            for (let ind01 = 0; ind01 < prmArray.length; ind01++) {
                let currRow = prmArray[ind01];

                if (!dicUniqueItems[currRow[prmKeyFieldName]]
                    && (!prmDicIgnoredValues || (!!prmDicIgnoredValues && !prmDicIgnoredValues[currRow[prmKeyFieldName]]))) {
                    dicUniqueItems[currRow[prmKeyFieldName]] = true;
                    if (!isStayInSameStructure) {
                        itemObj = {
                            value: currRow[prmKeyFieldName],
                            text: currRow[prmDisplayFieldName],
                            label: <span>{currRow[prmDisplayFieldName]}</span>
                        };

                        if (currRow.hasOwnProperty("row")) {
                            itemObj.row = currRow.row;
                        }
                        else {
                            itemObj.row = currRow;
                        }
                    }
                    else {
                        itemObj = currRow
                    }


                    arrOut.push(itemObj);
                }

            }
        }


        //sortArr(prmArray, prmKeyFieldName,)
        return arrOut;
    },

    // getSelectedArrFromDataSource: function (prmDataSource, prmIDFieldNameStr) {
    //     var outArr = null;

    //     outArr = $.map(prmDataSource, function (prmVal, prmKey) {
    //         if (prmVal.isSelected) {
    //             return prmVal[prmIDFieldNameStr];
    //         }

    //     });

    //     return outArr;
    // },


    sortArr: function (prmArr, prmSortFieldName, prmIsAsc) {
        let lstOut =  prmArr

        if (!!prmArr && Array.isArray(prmArr)) {
            lstOut = prmArr.sort((a, b) => {
                let outVal = 0

                try {
                    let valueA = a[prmSortFieldName];
                    let valueB = b[prmSortFieldName];

                    // Convert to Date if values are date strings
                    if (dataUtils.isDate(valueA) || dataUtils.isDate(valueB)) { //} typeof valueA === 'string' && !isNaN(Date.parse(valueA))) {
                        valueA = new Date(valueA);
                        valueB = new Date(valueB);
                    }

                    // Handle comparison for numbers and strings
                    if (valueA < valueB) {
                        outVal = prmIsAsc ? -1 : 1
                    }
                    else if (valueA > valueB) {
                        outVal = prmIsAsc ? 1 : -1
                    }
                }
                catch (ex) {
                    //DO NOTHING
                }

                return outVal; // Equal values
            });
        }


        // if (!!prmArr && !!prmSortFieldName) {
        //     if (!!prmIsAsc && prmIsAsc) {
        //         prmArr.sort(function (prmA, prmB) {
        //             let outVal = 0;
        //
        //             if (!!prmA && !!prmB){
        //                 if (prmA[prmSortFieldName] < prmB[prmSortFieldName]) {
        //                     outVal = -1;
        //                 }
        //                 if (prmA[prmSortFieldName] < prmB[prmSortFieldName]) {
        //                     outVal = -1;
        //                 }
        //                 else if (prmA[prmSortFieldName] > prmB[prmSortFieldName]) {
        //                     outVal = 1;
        //                 }
        //                 else {
        //                     outVal = 0;
        //                 }
        //             }
        //
        //
        //             return outVal;
        //         });
        //     }
        //     else {
        //         prmArr.sort(function (prmA, prmB) {
        //             let outVal;
        //
        //             if (!!prmA && !!prmB) {
        //                 if (prmA[prmSortFieldName] > prmB[prmSortFieldName]) {
        //                     outVal = -1;
        //                 } else if (prmA[prmSortFieldName] < prmB[prmSortFieldName]) {
        //                     outVal = 1;
        //                 } else {
        //                     outVal = 0;
        //                 }
        //             }
        //
        //             return outVal;
        //         });
        //     }
        // }


        return lstOut;
    },

    sortArrBoolean: function (prmArr, prmSortFieldName, prmIsTrueFirst) {

        if (!!prmIsTrueFirst && prmIsTrueFirst) {
            prmArr.sort(function (prmA, prmB) {
                var outVal;

                if (prmA[prmSortFieldName] === prmB[prmSortFieldName]) {
                    outVal = 0;
                }
                else if (!prmA[prmSortFieldName]) {
                    outVal = 1;
                }
                else {
                    outVal = -1;
                }

                return outVal;
            });
        }
        else {
            prmArr.sort(function (prmA, prmB) {
                var outVal;

                if (prmA[prmSortFieldName] === prmB[prmSortFieldName]) {
                    outVal = 0;
                }
                else if (!prmA[prmSortFieldName]) {
                    outVal = -1;
                }
                else {
                    outVal = 1;
                }

                return outVal;
            });

        }
    },

    getNestedJsonValue: function (prmObj, prmPropertyNameStr) {

        let currObj = prmObj;

        if (!!prmPropertyNameStr) {
            let arrPropertyName = prmPropertyNameStr.split('.');

            for (let ind01 = 0; ind01 < arrPropertyName.length; ind01++) {

                if (!!currObj) {

                    let currPropertyName = arrPropertyName[ind01];
                    currObj = currObj[currPropertyName];
                }
            }
        }

        return currObj;
    },

    setNestedJsonValue: function (prmObj, prmPropertyNameStr, prmValue, prmIsCreateNestedObjects) {
        if (prmObj == undefined || prmObj == null || !prmPropertyNameStr) { return; };

        var currObj = prmObj;

        var arrPropertyName = prmPropertyNameStr.split('.');


        for (var ind01 = 0; ind01 < arrPropertyName.length - 1; ind01++) {

            var currPropertyName = arrPropertyName[ind01];

            if (prmIsCreateNestedObjects && !currObj[currPropertyName]) {
                currObj[currPropertyName] = {};
            }

            if (currObj == undefined) {
                break;
            }
            else {
                currObj = currObj[currPropertyName];
            }
        }

        var currPropertyName = arrPropertyName[arrPropertyName.length - 1];

        if (!!currObj) {
            currObj[currPropertyName] = prmValue;
        }
        // return prmObj;
    },
    getElementsByElementTag: function (prmTag) {
        let elements = store.getState().store_PageStructure.lstElementsFlat;

        var outArr = elements.filter(function (currElement) {

            if (!!currElement.ElementTags) {

                var tags = currElement.ElementTags.split(",");
                if (tags.indexOf(prmTag) >= 0) {
                    return true;
                }
            }
        });

        return outArr;
    },
    getElementByClientID: function (prmElementClientID) {
        let lstElements = [...store.getState().store_PageStructure.lstElementsFlat];
        let outObj = null;

        if (!!lstElements) {
            let currElementWrapperObj = lstElements.find((prmElementItem) => {
                return prmElementItem?.ElementObj?.ClientID == prmElementClientID
            })

            if (!!currElementWrapperObj) {
                outObj = currElementWrapperObj.ElementObj;
            }
            // for (var ind01 = 0; ind01 < elements.length; ind01++) {
            //     var currElement = elements[ind01];
            //
            //     if (currElement?.ElementObj?.ClientID == prmElementClientID) {
            //         outObj = currElement;
            //         break;
            //     }
            // }
        }


        return outObj;
    },
    parseValueByDataType: function (prmDataType, prmValue) {

        var outObj = prmValue;

        if (!!prmDataType
            && !!prmValue) {

            switch (prmDataType) {

                case 'Boolean':
                    outObj = prmValue == 'true';
                    break;

                case 'Date':
                    outObj = new Date(prmValue);
                    break;

                case 'Decimal':
                    outObj = parseFloat(prmValue);
                    break;

                case 'Integer':
                    outObj = parseInt(prmValue);
                    break;

                case 'String':
                default:
                    break;
            }
        }

        return outObj;

    },
    getDataBindObject: function (prmPageElement, prmDataBindStr) {

        var outObj = {};

        if (!!prmPageElement
            && !!prmPageElement.temp
            && !!prmPageElement.temp.rowDataObj) {

            outObj = prmPageElement.temp.rowDataObj;
        }
        else {
            if (!!prmDataBindStr) {

                outObj = dataUtils.getDataItem(prmDataBindStr);
            }
            else if (!!prmPageElement && !!prmPageElement.DataBindStr && prmPageElement.DataBindStr.length > 0) {
                var dataBindParent = prmPageElement.DataBindStr.substring(0, prmPageElement.DataBindStr.lastIndexOf("."));

                outObj = dataUtils.getDataItem(dataBindParent);
            }
        }

        return outObj;
    },
    // getDataItem: function (prmDataBindStr) {
    //     let outVal;
    //
    //     if (!!prmDataBindStr && prmDataBindStr.startsWith("FreeBinding.")) {
    //         prmDataBindStr = prmDataBindStr.substring("FreeBinding.".length);
    //     }
    //
    //     if (!!prmDataBindStr && prmDataBindStr.length > 0) {
    //         let currPageData = store.getState().store_PageData.data;
    //
    //         if (prmDataBindStr.endsWith(".[RowsCount]")){
    //             let nestedDataObj = dataUtils.getNestedJsonValue(currPageData, prmDataBindStr.substring(0,prmDataBindStr.length -".[RowsCount]".length));
    //
    //             if (!!nestedDataObj){
    //                 outVal = nestedDataObj.length;
    //             }
    //             else {
    //                 outVal = 0;
    //             }
    //         }
    //         else {
    //             outVal = dataUtils.getNestedJsonValue(currPageData, prmDataBindStr);
    //         }
    //     }
    //
    //     return outVal;
    // },
    setNestedJsonValue_IncludeArray: function (prmObj, prmPropertyNameStr, prmValue) {

        var currObj = prmObj;

        var arrPropertyName = prmPropertyNameStr.split('.');
        var isExit = false;

        for (var ind01 = 0; ind01 < arrPropertyName.length - 1; ind01++) {

            var currPropertyName = arrPropertyName[ind01];

            //Comment: is array
            if (currPropertyName.indexOf("[") >= 0
                && currPropertyName.indexOf("]") >= 0) {

                var currPropNameNoBrakets = currPropertyName.substring(0, currPropertyName.indexOf("["));

                var currArray = currObj[currPropNameNoBrakets]

                if (!!currArray && Array.isArray(currArray)) {

                    var currArrIndex = currPropertyName.substring(currPropertyName.indexOf("["));
                    var currIndex = currArrIndex.replace("[", "").replace("]", "");

                    currObj = currArray[currIndex];
                }

            }
            else if (!!currObj) {

                currObj = currObj[currPropertyName];
            }
            else {
                isExit = true;
                break;
            }


        }

        if (!isExit) {
            var currPropertyName = arrPropertyName[arrPropertyName.length - 1];

            currObj[currPropertyName] = prmValue;
        }
    },
    getChangesListForArray: function (prmArrOrigin, prmArrNew, prmPrimaryObjMetaData) {

        var outArr = [];

        var dicOriginObjs = {};
        for (var ind02 = 0; ind02 < prmArrOrigin.length; ind02++) {
            var currOriginObj = prmArrOrigin[ind02];

            var currKey = currOriginObj[prmPrimaryObjMetaData.KeyProperty];
            dicOriginObjs[currKey] = currOriginObj;
        }

        var newKeyNumber = -1

        var dicNewObjs = {};
        for (var ind02 = 0; ind02 < prmArrNew.length; ind02++) {
            var currNewObj = prmArrNew[ind02];

            var currKey = currNewObj[prmPrimaryObjMetaData.KeyProperty];
            if (currKey === undefined) {
                currKey = 0;
            }
            if (currKey == 0) {
                currKey = newKeyNumber;
                currNewObj[prmPrimaryObjMetaData.KeyProperty] = newKeyNumber;
                newKeyNumber--;
            }


            dicNewObjs[currKey] = currNewObj;
        }


        //find deleted items
        for (var currKey in dicOriginObjs) {

            if (!dicNewObjs.hasOwnProperty(currKey)) {

                var newChangeListItem = {
                    ObjName: prmPrimaryObjMetaData.Name,
                    ID: currKey,
                    SaveState: "Delete"
                };

                outArr.push(newChangeListItem);


                //var currDeleteObj = dicNewObjs[currKey];

                //for (var ind01 = 0; ind01 < prmArrNavObjMetaDatas.length; ind01++) {

                //    var currNavObjMetaData = prmArrNavObjMetaDatas[ind01];

                //    if (!!currDeleteObj[currNavObjMetaData.Name]) {

                //        var currArrNavDataObjs = currDeleteObj[currNavObjMetaData.Name];

                //        for (var ind02 = 0; ind02 < currArrNavDataObjs.length; ind02++) {

                //            var currNavDataObj = currArrNavDataObjs[ind02];

                //            if (currNavDataObj[currNavObjMetaData.KeyProperty] > 0) {

                //                var newNavChangeListItem = {
                //                    ObjName: currNavObjMetaData.Name,
                //                    ID: currNavDataObj[currNavObjMetaData.KeyProperty],
                //                    SaveState: "Delete"
                //                };

                //                outArr.push(newChangeListItem);
                //            }
                //        }
                //    }

                //}
            }
        }


        //find add or modified objects
        for (var currKey in dicNewObjs) {

            if (!dicOriginObjs.hasOwnProperty(currKey)) {

                var newChangeListItem = {
                    ObjName: prmPrimaryObjMetaData.Name,
                    ID: currKey,
                    SaveState: "New"
                };

                outArr.push(newChangeListItem);
            }
            else {

                // check if object modified
                var originObj = dicOriginObjs[currKey];
                var newObj = dicNewObjs[currKey];

                if (this.isObjModified(originObj, newObj, prmPrimaryObjMetaData.IgnoreProperties)) {

                    var newChangeListItem = {

                        ObjName: prmPrimaryObjMetaData.Name,
                        ID: currKey,
                        SaveState: "Modify"
                    };

                    outArr.push(newChangeListItem);
                }


                if (!!prmPrimaryObjMetaData.ArrNavObjMetaData) {

                    for (var ind01 = 0; ind01 < prmPrimaryObjMetaData.ArrNavObjMetaData.length; ind01++) {

                        var currNavObjMetaData = prmPrimaryObjMetaData.ArrNavObjMetaData[ind01];

                        var arrOriginNav = originObj[currNavObjMetaData.Name];
                        var arrNewNav = newObj[currNavObjMetaData.Name];

                        var arrChanges = this.getChangesListForArray(arrOriginNav, arrNewNav, currNavObjMetaData);

                        outArr = outArr.concat(arrChanges);
                    }
                }
            }
        }





        return outArr;
    },

    isObjModified: function (prmOriginObj, prmTagetObj, prmIgnoreProperties, prmArrOutChangedKeys) {

        var outVal = false;
        prmArrOutChangedKeys = [];

        var arrIgnoreProperties = prmIgnoreProperties.split(",");

        for (var key in prmOriginObj) {

            if (arrIgnoreProperties.indexOf(key) === -1) {

                if (prmOriginObj.hasOwnProperty(key) && prmTagetObj.hasOwnProperty(key)) { //comment: both objects has the relevant key
                    if (prmOriginObj[key] instanceof Date
                        && prmOriginObj[key].toString() != prmTagetObj[key].toString()) {//Comment: is date and diffrent
                        prmArrOutChangedKeys.push(key);
                        outVal = true;
                    }
                    else if (this.isNativeProperty(prmOriginObj[key])
                        && prmOriginObj[key] != prmTagetObj[key]) {//Comment: is native and diffrent
                        prmArrOutChangedKeys.push(key);
                        outVal = true;
                        break;
                    }
                }
                else if (!prmOriginObj.hasOwnProperty(key) && prmTagetObj.hasOwnProperty(key)) {
                    prmArrOutChangedKeys.push(key);
                    outVal = true;
                    break;

                }
                else if (prmOriginObj.hasOwnProperty(key) && !prmTagetObj.hasOwnProperty(key)) {
                    prmArrOutChangedKeys.push(key);
                    outVal = true;
                    break;

                }
                //
                // if (!prmOriginObj[key] && !prmTagetObj[key]) {//Comment: both null
                //
                //     continue;
                // }
                // else if ((!prmOriginObj[key] && prmTagetObj[key])
                //     || (prmOriginObj[key] && !prmTagetObj[key])) {//Comment: one null and the other one not null
                //
                //     prmArrOutChangedKeys.push(key);
                //     outVal = true;
                //     // break;
                // }
                // else if (this.isNativeProperty(prmOriginObj[key])
                //     && prmOriginObj[key] != prmTagetObj[key]) {//Comment: is native and diffrent
                //     prmArrOutChangedKeys.push(key);
                //     outVal = true;
                //     // break;
                // }
                // else if (prmOriginObj[key] instanceof Date
                //     && prmOriginObj[key].toString() != prmTagetObj[key].toString()) {//Comment: is date and diffrent
                //     prmArrOutChangedKeys.push(key);
                //     outVal = true;
                //     // break;
                // }
            }
        }

        return outVal;

    },
    /*
    
        isNativeProperty: function (prmProperty) {
            var outVal = false;
    
            if (typeof prmProperty == "string"
                || typeof prmProperty == "number"
                || typeof prmProperty == "boolean") {
    
                outVal = true;
            }
    
            return outVal;
        },*/


    // bindDataObjToDom: function (prm$DomScopeElement, prmDataObj, prmDisplayFormat) {

    //     prm$DomScopeElement.find("[ap-databind]").each(function () {

    //         var $bindedElement = $(this)

    //         var currDataBindFieldName = $bindedElement.attr("ap-databind");

    //         var currDataBindValue = dataUtils.getNestedJsonValue(prmDataObj, currDataBindFieldName);

    //         if ($bindedElement.is("input")) {

    //             var currInputType = $bindedElement.attr("type");
    //             if (currInputType == "checkbox") {

    //                 $bindedElement.prop('checked', currDataBindValue);
    //             }
    //             else {
    //                 if (currDataBindValue instanceof Date) {

    //                     //currDataBindValue = moment(currDataBindValue).format(prmDisplayFormat);
    //                     if ($bindedElement.hasClass("hasDatepicker")) {

    //                         $bindedElement.datepicker('setDate', currDataBindValue);
    //                     }
    //                     else {

    //                         currDataBindValue = moment(currDataBindValue).format(prmDisplayFormat);
    //                         $bindedElement.val(currDataBindValue);
    //                     }
    //                 }
    //                 else {

    //                     $bindedElement.val(currDataBindValue);
    //                 }

    //             }
    //         }
    //         else if ($bindedElement.is("select")) {
    //             $bindedElement.val(currDataBindValue);
    //         }
    //         else {

    //             var displayFormat = "";

    //             var currElementDisplayFormat = $bindedElement.attr("ap-databind-displayformat");

    //             if (!currElementDisplayFormat) {
    //                 currElementDisplayFormat = $bindedElement.data("displayformat");
    //             }

    //             if (!currElementDisplayFormat) {
    //                 var $closetDisplayFormatCobj = $bindedElement.closest("[ap-databind-displayformat]");
    //                 currElementDisplayFormat = $closetDisplayFormatCobj.attr("ap-databind-displayformat");

    //                 if (!currElementDisplayFormat) {
    //                     $closetDisplayFormatCobj = $bindedElement.closest("[data-displayformat]");
    //                     currElementDisplayFormat = $closetDisplayFormatCobj.data("displayformat");
    //                 }
    //             }



    //             if (!!currElementDisplayFormat && currElementDisplayFormat.trim() != '') {
    //                 displayFormat = currElementDisplayFormat;
    //             }
    //             else if (!!prmDisplayFormat && prmDisplayFormat.trim() != '') {
    //                 displayFormat = prmDisplayFormat;
    //             }


    //             if (displayFormat.trim() != '') {

    //                 if ($.isNumeric(currDataBindValue)) {

    //                     currDataBindValue = $.formatNumber(currDataBindValue, { format: displayFormat });
    //                 }
    //                 else if (currDataBindValue instanceof Date) {

    //                     currDataBindValue = moment(currDataBindValue).format(displayFormat);
    //                 }
    //             }


    //             $bindedElement.html(currDataBindValue);
    //         }
    //     });

    // },

    getElementTypeByCode: function (prmElementTypeCode) {
        let elements = store.getState().store_PageStructure.lstElementsFlat;

        var outObj = elements[prmElementTypeCode];

        return outObj;
    },
    getFormattedNumberWithCommas: function (prmValue, prmNumDecimalPlaces, prmPrefix, prmSuffix) {
        var currVal = prmValue;

        if (prmNumDecimalPlaces != null && prmNumDecimalPlaces != undefined) {
            currVal = Math.round(currVal * Math.pow(10, prmNumDecimalPlaces)) / Math.pow(10, prmNumDecimalPlaces)
        }

        var outVal = currVal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        if (!!prmPrefix) {
            outVal = prmPrefix + outVal;
        }

        if (!!prmSuffix) {
            outVal = outVal + prmSuffix;
        }

        return outVal;
    },

    // bindDataObjFromDom: function (prm$DomScopeElement, prmDataObj) {

    //     prm$DomScopeElement.find("[ap-databind]").each(function () {

    //         var $bindedElement = $(this);

    //         var currDataBindFieldName = $bindedElement.attr("ap-databind");

    //         var value = null;

    //         if ($bindedElement.is("input")
    //             || $bindedElement.is("textarea")) {

    //             var value = null;
    //             var currInputType = $bindedElement.attr("type");
    //             if (currInputType == "checkbox") {
    //                 value = $bindedElement.is(':checked');
    //             }
    //             else {

    //                 if ($bindedElement.hasClass("hasDatepicker")) {

    //                     value = $bindedElement.datepicker('getDate');
    //                 }
    //                 else {

    //                     value = $bindedElement.val();
    //                 }
    //             }
    //         }
    //         else if ($bindedElement.is("select")) {

    //             value = $bindedElement.val();
    //         }

    //         if (value != null) {

    //             dataUtils.setNestedJsonValue(prmDataObj, currDataBindFieldName, value);
    //         }
    //     });
    // },

    //createArrDataWithIsSelectedField(arrUserAuthItems,arrCompanies)
    // createArrDataWithIsSelectedField: function (prmArrData, prmArrRepository, prmKeyFieldName) {

    //     var outArr = [];

    //     var dicArrData = {};
    //     if (!!prmArrData) {
    //         for (var ind01 = 0; ind01 < prmArrData.length; ind01++) {

    //             var currDataObj = prmArrData[ind01];

    //             var currKey = currDataObj[prmKeyFieldName];
    //             dicArrData[currKey] = currDataObj;
    //         }
    //     }

    //     for (var ind01 = 0; ind01 < prmArrRepository.length; ind01++) {

    //         var currRepositoryObj = prmArrRepository[ind01];

    //         var originRepositoryObjStr = JSON.stringify(currRepositoryObj);
    //         var newObj = $.parseJSON(originRepositoryObjStr);

    //         var currKeyValue = newObj[prmKeyFieldName];
    //         if (dicArrData.hasOwnProperty(currKeyValue)) {

    //             newObj.isSelected = true;
    //         }
    //         else {

    //             newObj.isSelected = false;
    //         }

    //         outArr.push(newObj);
    //     }

    //     return outArr;
    // },

    //comment: set isSelected for target array by prmArrSourceValues as an array of strings
    updateIsSelectedByStringArray: function (prmArrSourceValues, prmArrTargetList, prmTargetKeyField) {
        for (var ind01 = 0; ind01 < prmArrTargetList.length; ind01++) {
            var currItem = prmArrTargetList[ind01];

            currItem.isSelected = false;

            if (!!prmTargetKeyField
                && prmArrSourceValues.indexOf(currItem[prmTargetKeyField]) > -1) {
                currItem.isSelected = true;
            }

        }

        return prmArrTargetList;
    },

    // updateArrDataByRepositoryWithIsSelected: function (prmArrData, prmArrRepositoryWithIsSelected, prmKeyFieldName, prmDefaultValuesObj) {

    //     var arrDataOut = [];

    //     var dicArrData = {};
    //     if (!!prmArrData) {
    //         for (var ind01 = 0; ind01 < prmArrData.length; ind01++) {

    //             var currDataObj = prmArrData[ind01];

    //             var currKey = currDataObj[prmKeyFieldName];
    //             dicArrData[currKey] = currDataObj;
    //         }
    //     }

    //     for (var ind01 = 0; ind01 < prmArrRepositoryWithIsSelected.length; ind01++) {

    //         var currRepositoryObj = prmArrRepositoryWithIsSelected[ind01];

    //         if (currRepositoryObj.isSelected) {

    //             var currDataObj;

    //             var currKey = currRepositoryObj[prmKeyFieldName];
    //             if (dicArrData.hasOwnProperty(currKey)) {

    //                 currDataObj = dicArrData[currKey];
    //             }
    //             else {

    //                 //clone
    //                 var defaultValuesObjStr = JSON.stringify(prmDefaultValuesObj);
    //                 currDataObj = $.parseJSON(defaultValuesObjStr);

    //                 //set key
    //                 currDataObj[prmKeyFieldName] = currKey;
    //             }

    //             arrDataOut.push(currDataObj);
    //         }
    //     }

    //     return arrDataOut;
    // },

    clearObjectProperties: function (prmObject, prmArrProperties, prmValue) {

        if (!!prmObject) {
            for (var key in prmObject) {
                if (prmArrProperties.indexOf(key) > -1) {
                    prmObject[key] = prmValue;
                }
            }
        }
    },

    convertObjectToArray: function (prmObj) {

        let lstOut = [];

        for (let currKey in prmObj) {
            let currItemObj = prmObj[currKey];
            lstOut.push(currItemObj);
        }

        return lstOut;
    },

    convertArrayToDicObjectByFilterEq: function (prmArr, prmKeyFieldName, prmFilterPropertyName, prmFilterPropertyValue) {
        var outDicObj = {};

        var arrClonedArray = prmArr.filter(function (e) {
            return e[prmFilterPropertyName] == prmFilterPropertyValue;
        });

        outDicObj = this.convertArrayToDicObject(arrClonedArray, prmKeyFieldName);

        return outDicObj;
    },

    convertArrayToDicObject: function (prmArr, prmKeyFieldName) {
        var outDicObj = {};
        if (prmArr === undefined || prmArr === null) {
            return outDicObj;
        }
        for (var ind01 = 0; ind01 < prmArr.length; ind01++) {

            var currObj = prmArr[ind01];

            if (typeof currObj === 'object') {

                var currFieldName = dataUtils.getNestedJsonValue(currObj, prmKeyFieldName);
                outDicObj[currFieldName] = currObj;
            }
            else {
                outDicObj[currObj] = currObj;
            }
        }

        return outDicObj;
    },

    convertSimpleArrayToDictionary: function (prmArr) {
        let dicOut = prmArr.reduce((prmItem, prmValue) => {
            prmItem[prmValue] = prmValue;

            return prmItem;
        }, {});

        return dicOut
    },

    //comment: convert a flat array (of native type: string, int etc) to dictionary
    convertFlatArrayToDic: function (prmArr, prmValue) {
        var outDicObj = {};

        if (!!prmArr) {
            for (var ind01 = 0; ind01 < prmArr.length; ind01++) {

                var currItem = prmArr[ind01];

                if (!!prmValue) {
                    outDicObj[currItem] = prmValue;
                }
                else {
                    outDicObj[currItem] = currItem;
                }
            }
        }

        return outDicObj;
    },

    getObjectNumProperties: function (prmObject) {
        var outNumProperties = 0; //, key;

        for (var key in prmObject) {
            outNumProperties++;
        }
        //for (key in prmObject) {
        //    //if (obj.hasOwnProperty(key))
        //    size++;
        //}

        return outNumProperties;
    },

    //cloneObjectWithoutProperties: function (obj, keys) {
    //    var target = {};

    //    for (var key in obj) {
    //        if ((keys.indexOf(key) == 0)
    //                && (!Object.prototype.hasOwnProperty.call(obj, key))) {

    //            target[key] = obj[key];
    //        }
    //    }

    //    return target;
    //},

    isDate: function (prmValue) {
        let outVal = prmValue instanceof Date

        return outVal
    },

    parseData: function (prmSourceStr) {
        let outObj = null

        try {
            if (!!prmSourceStr && typeof prmSourceStr == 'string' ) {
                outObj = JSON.parse(prmSourceStr);
            }
        }
        catch (ex) {
            utils_log.writeObjectToLog("*** parseData Error",prmSourceStr,ex)
        }

        return outObj;
    },

    isDateContainsTime:function(prmDate){
        let outVal = false;

        if (!!prmDate){
            let currDT = new Date(prmDate)

            if (currDT.getHours() > 0 || currDT.getMinutes() >0 || currDT.getSeconds() > 0){
                outVal = true;
            }
        }

        return outVal;
    },

    clone: function (prmSource) {

        var outObj;

        if (!!prmSource) {
            var sourceStr = JSON.stringify(prmSource);
            outObj = JSON.parse(sourceStr);
        }
        else {
            outObj = prmSource;
        }



        return outObj;
    },

    //clone: function (prmSource, prmIgnoreFields) {

    //    var outObj;

    //    if (!!prmSource) {


    //        var dicIgnoreData = {};
    //        var arrIgnoreFields = [];

    //        if (!!prmIgnoreFields) {

    //            var arrIgnoreFields = prmIgnoreFields.split(",");

    //            if (arrIgnoreFields.length > 0) {

    //                for (var ind01 = 0; ind01 < arrIgnoreFields.length; ind01++) {

    //                    var currIgnoreFieldName = arrIgnoreFields[ind01];
    //                    var currValue = dataUtils.getNestedJsonValue(prmSource, currIgnoreFieldName);

    //                    dataUtils.setNestedJsonValue(dicIgnoreData, currIgnoreFieldName, currValue);

    //                    dataUtils.setNestedJsonValue(prmSource, currIgnoreFieldName, undefined);
    //                }
    //            }
    //        }

    //        var sourceStr = JSON.stringify(prmSource);
    //        outObj = JSON.parse(sourceStr);

    //        if (arrIgnoreFields.length > 0) {

    //            for (var ind01 = 0; ind01 < arrIgnoreFields.length; ind01++) {

    //                var currIgnoreFieldName = arrIgnoreFields[ind01];
    //                var currValue = dataUtils.getNestedJsonValue(dicIgnoreData, currIgnoreFieldName);

    //                dataUtils.setNestedJsonValue(prmSource, currIgnoreFieldName, currValue);

    //            }
    //        }
    //    }
    //    else {
    //        outObj = prmSource;
    //    }



    //    return outObj;
    //},


    // ap_FormatNumber: function (prmVal, prmFormat) {

    //     var outVal = "";

    //     if (prmVal == null || prmVal == undefined) {
    //         return outVal;

    //     }
    //     else {
    //         outVal = $.formatNumber(prmVal, { format: prmFormat });
    //     }

    //     return outVal;
    // },


    indexOfInArrayByProperty: function (array, attr, value) {
        var outVal = -1;

        for (var ind01 = 0; ind01 < array.length; ind01 += 1) {
            if (array[ind01].hasOwnProperty(attr) && array[ind01][attr] == value) {
                outVal = ind01;
                break;
            }
        }

        return outVal;
    },

    indexOfInArrayByString: function (array, value) {
        for (var i = 0; i < array.length; i += 1) {
            if (array[i] === value) {
                return i;
            }
        }
    },

    getFirstProprtyValueInJsonObject: function (prmObj) {

        var outVal = null;

        for (var currKey in prmObj) {
            outVal = prmObj[currKey];
        }

        return outVal;

    },


    getURLQueryStringAsJson: function () {
        // This function is anonymous, is executed immediately and
        // the return value is assigned to QueryString!
        var query_string = {};
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            // If first entry with this name
            if (typeof query_string[pair[0]] === "undefined") {
                query_string[pair[0].toLowerCase()] = pair[1];
                // If second entry with this name
            } else if (typeof query_string[pair[0]] === "string") {
                var arr = [query_string[pair[0].toLowerCase()], pair[1]];
                query_string[pair[0].toLowerCase()] = arr;
                // If third or later entry with this name
            } else {
                query_string[pair[0].toLowerCase()].push(pair[1]);
            }
        }
        return query_string;
    },

    removeItemFromArray: function (prmArray, prmItemToRemove) {

        var indToRemove = prmArray.indexOf(prmItemToRemove);

        if (indToRemove > -1) {

            prmArray.splice(indToRemove, 1);
        }
    },

    // removeUsersFromArray: function (prmUsersList, prmIsRemoveNonTraderUsers, prmIsRemoveInActiveUsers, prmIsRemoveSystemUser) {
    //     var outObj = prmUsersList;
    //     var ind01;

    //     if (!!outObj) {
    //         for (ind01 = 0; ind01 < outObj.length; ++ind01) {
    //             if (outObj[ind01].IsTrader == false && prmIsRemoveNonTraderUsers) {
    //                 outObj.splice(ind01--, 1);
    //             }
    //             else if (outObj[ind01].IsActive == false && prmIsRemoveInActiveUsers) {
    //                 outObj.splice(ind01--, 1);
    //             }
    //             else if (outObj[ind01].UserID == jsConfig.systemUserID && prmIsRemoveSystemUser) {
    //                 outObj.splice(ind01--, 1);
    //             }
    //         }
    //     }

    //     return outObj;
    // },

    // getDefaultUserGroupTypeID: function () {
    //     //comment:  check if the user is related to Amitim or Nostro and return it as a default.
    //     //          Users that can view both Groups will not have a default value, in this case the function return 0

    //     var outVal = 0;
    //     var currUserObj = jsGlobals.getDataObj().CurrSessionUser;

    //     if (currUserObj.CanViewColleagues == true && currUserObj.CanViewFunds == false) {
    //         outVal = jsConfig.C_AmitimGroup
    //     }
    //     else if (currUserObj.CanViewColleagues == false && currUserObj.CanViewFunds == true) {
    //         outVal = jsConfig.C_NostroGroup
    //     }

    //     return outVal;
    // },

    removeUnhandledPropertiesFromDataObject: function (prmObject) {
        var arrRemoveProperties = [];
        var dicRemoveProperties = {
            "DicExtFieldNames": true,
            "$$hashKey": true,
            "ApplyooLastID": true,
            "ApplyooOriginalID": true,
            "LastUpdatedDT": true,
            "CreatedDT": true
        };
        if (!!prmObject) {
            for (var currKey in prmObject) {
                if (!!dicRemoveProperties[currKey]) {
                    prmObject[currKey] = null;
                    arrRemoveProperties.push(currKey);
                }
            }

            for (var ind01 = 0; ind01 < arrRemoveProperties.length; ind01++) {
                delete prmObject[arrRemoveProperties[ind01]];
            }
        }

        return prmObject;
    },

    removeUnhandledPropertiesFromDataArray: function (prmArrData) {
        if (!!prmArrData) {
            if (!!prmArrData.length) {
                for (var ind01 = 0; ind01 < prmArrData.length; ind01++) {
                    prmArrData[ind01] = dataUtils.removeUnhandledPropertiesFromDataObject(prmArrData[ind01]);
                }
            }
            else {
                for (var currKey in prmArrData) {
                    prmArrData[currKey] = dataUtils.removeUnhandledPropertiesFromDataArray(prmArrData[currKey]);
                }
            }
        }

        return prmArrData;
    },

    convertArrayToHierarchicalList: function (prmArray, prmParentFieldName, prmIDFieldName, prmItemsPropertyName) {

        var hierarchicalList = [];

        for (var ind01 = 0; ind01 < prmArray.length; ind01++) {

            if (!prmArray[ind01][prmParentFieldName]) {

                dataUtils.convertArrayToHierarchicalListRecurse(prmArray, prmParentFieldName, prmIDFieldName, prmArray[ind01], prmItemsPropertyName, hierarchicalList)

                hierarchicalList.push(prmArray[ind01]);

            }
        }

        return hierarchicalList;
    },

    convertArrayToHierarchicalListRecurse: function (prmArray, prmParentFieldName, prmIDFieldName, currItem, prmItemsPropertyName, hierarchicalList) {

        for (var ind01 = 0; ind01 < prmArray.length; ind01++) {

            if (prmArray[ind01][prmParentFieldName] == currItem[prmIDFieldName]) {

                if (!currItem[prmItemsPropertyName]) {

                    currItem[prmItemsPropertyName] = [];
                }

                dataUtils.convertArrayToHierarchicalListRecurse(prmArray, prmParentFieldName, prmIDFieldName, prmArray[ind01], prmItemsPropertyName, hierarchicalList);

                currItem[prmItemsPropertyName].push(prmArray[ind01]);
            }
        }

        if (!!currItem.LstSubFolders && currItem.LstSubFolders.length > 0) {
            for (var ind02 = 0; ind02 < currItem.LstSubFolders.length; ind02++) {
                var currSubFolder = currItem.LstSubFolders[ind02];

                dataUtils.convertArrayToHierarchicalListRecurse(prmArray, prmParentFieldName, prmIDFieldName, currSubFolder, prmItemsPropertyName, hierarchicalList);
            }
        }

    },

    convertHierarchicalListToArray: function (prmHierarchialList, prmParentFieldName, prmIDFieldName, prmItemsPropertyName) {

        var convertedArray = [];

        for (var ind01 = 0; ind01 < prmHierarchialList.length; ind01++) {

            convertedArray.push(prmHierarchialList[ind01]);
            dataUtils.convertHierarchicalListToArrayRecurse(prmHierarchialList[ind01], convertedArray, prmParentFieldName, prmIDFieldName, prmItemsPropertyName)

        }

        return convertedArray;

    },

    convertHierarchicalListToArrayRecurse: function (currItem, convertedArray, prmParentFieldName, prmIDFieldName, prmItemsPropertyName) {

        var subItems = currItem[prmItemsPropertyName];
        if (!!subItems) {



            for (var ind01 = 0; ind01 < subItems.length; ind01++) {

                var currSubItem = subItems[ind01];

                currSubItem[prmParentFieldName] = currItem[prmIDFieldName];

                convertedArray.push(currSubItem);
                dataUtils.convertHierarchicalListToArrayRecurse(subItems[ind01], convertedArray, prmParentFieldName, prmIDFieldName, prmItemsPropertyName);

            }
        }
    },

    findOwnPropertyInPatentScopes: function (prmScope, prmProperty) {
        var outObj = null;

        var currScopeObj = prmScope;

        do {

            if (currScopeObj.hasOwnProperty(prmProperty)) {
                outObj = currScopeObj[prmProperty];
            }
            currScopeObj = currScopeObj.$parent;

        } while (currScopeObj && !outObj);

        return outObj;
    },

    toNumberOrZero: function (prmValue) {
        var outVal = parseFloat(prmValue);
        if (isNaN(outVal)) {
            outVal = 0;
        }
        return outVal;
    },

    isFloat: function isFloat(prmValue) {
        return Number(prmValue) === prmValue && prmValue % 1 !== 0;
    },

    isInt: function isInt(prmValue) {
        return Number(prmValue) === prmValue && prmValue % 1 === 0;
    },

    isBoolean: function isInt(prmValue) {
        return typeof prmValue === "boolean" || prmValue == "true" || prmValue == "false";
    },

    isString: function isString(prmValue) {
        return typeof prmValue === "string";
    },

    roundValue: function (prmValue, prmNumDecimalPoints) {
        var factor = Math.pow(10, prmNumDecimalPoints);

        var outVal = Math.round(prmValue * factor) / factor;

        return outVal;
    },

    replaceAll: function (prmStr, prmFind, prmReplace) {

        var outStr = prmStr.split(prmFind).join(prmReplace);

        return outStr;
    },


    generateGuid: function () {

        var newGuidStr = s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();



        return newGuidStr;


        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
    },


    //replaceInObject: function (prmObj, prmFind, prmReplace, prmArrIgnoredPath, refParentPath) {

    //    //TODO: refParentPath -> don't forget to decide how to handle on array path too

    //    if (!!prmObj
    //        && !!prmFind) {

    //        var isPrmObjNative = dataUtils.isNativeProperty(prmObj);

    //        if (!isPrmObjNative) {

    //            var isFunction = typeof prmObj == 'function';

    //            if (!isFunction) {

    //                var numOfNested = refParentPath.split('.');

    //                if (numOfNested.length > 15) {

    //                    console.log('too many nested properties: >> ' + refParentPath)
    //                    return;
    //                }

    //                if (Array.isArray(prmObj)) {

    //                    for (var ind01 = 0; ind01 < prmObj.length; ind01++) {

    //                        var currPropValue = prmObj[ind01];

    //                        if (!!currPropValue) {

    //                            var isPropValueNative = dataUtils.isNativeProperty(currPropValue);

    //                            if (isPropValueNative) {
    //                                //Comment: if array of native elements -> Ignore
    //                            }
    //                            else {

    //                                var currPath = refParentPath;
    //                                if (!!currPath) {

    //                                    currPath += '.';
    //                                }
    //                                currPath += '[' + ind01 + ']';

    //                                dataUtils.replaceInObject(currPropValue, prmFind, prmReplace, prmArrIgnoredPath, currPath);
    //                            }
    //                        }
    //                    }
    //                }
    //                else if (Object.keys(prmObj).length > 0) {

    //                    for (var currKey in prmObj) {

    //                        if (currKey.trim().toLowerCase() != 'temp') {


    //                            var currPropValue = prmObj[currKey];

    //                            if (!!currPropValue) {

    //                                var isPropValueNative = dataUtils.isNativeProperty(currPropValue);

    //                                if (isPropValueNative) {

    //                                    if (typeof currPropValue == "string") {

    //                                        if (currPropValue.trim().toLowerCase() === prmFind.trim().toLowerCase()) {
    //                                            prmObj[currKey] = prmReplace;
    //                                        }
    //                                    }
    //                                }
    //                                else {

    //                                    var currPath = refParentPath;
    //                                    if (!!currPath) {

    //                                        currPath += '.';
    //                                    }
    //                                    currPath += currKey;

    //                                    dataUtils.replaceInObject(currPropValue, prmFind, prmReplace, prmArrIgnoredPath, currPath);
    //                                }
    //                            }
    //                        }
    //                        else {
    //                            //        var a = 1;
    //                        }
    //                    }
    //                }
    //            }


    //        }
    //    }
    //},

    getPathInObjectForValue: function (prmObj, prmFind, prmArrIgnoredPath, refParentPath) {

        var outArr = [];

        if (!!prmObj
            && !!prmFind) {

            var isPrmObjNative = dataUtils.isNativeProperty(prmObj);

            if (!isPrmObjNative) {

                var isFunction = typeof prmObj == 'function';

                if (!isFunction) {

                    var numOfNested = refParentPath.split('.');

                    if (numOfNested.length > 15) {

                        utils_log.writeToLog('too many nested properties: >> ' + refParentPath)
                        return outArr;
                    }

                    if (Array.isArray(prmObj)) {

                        for (var ind01 = 0; ind01 < prmObj.length; ind01++) {

                            var currPropValue = prmObj[ind01];

                            if (!!currPropValue) {

                                var isPropValueNative = dataUtils.isNativeProperty(currPropValue);

                                if (isPropValueNative) {
                                    //Comment: if array of native elements -> Ignore
                                }
                                else {

                                    var currPath = refParentPath;
                                    //if (!!currPath) {

                                    //    currPath += '.';
                                    //}
                                    currPath += '[' + ind01 + ']';

                                    var currResultsArr = dataUtils.getPathInObjectForValue(currPropValue, prmFind, prmArrIgnoredPath, currPath);

                                    if (!!currResultsArr && currResultsArr.length > 0) {

                                        outArr = outArr.concat(currResultsArr);
                                    }
                                }
                            }
                        }
                    }
                    else if (Object.keys(prmObj).length > 0) {

                        for (var currKey in prmObj) {

                            var currPath = refParentPath;
                            if (!!currPath) {

                                currPath += '.';
                            }
                            currPath += currKey;

                            if (prmArrIgnoredPath.indexOf(currPath) == -1) {


                                var currPropValue = prmObj[currKey];

                                if (!!currPropValue) {

                                    var isPropValueNative = dataUtils.isNativeProperty(currPropValue);

                                    if (isPropValueNative) {

                                        if (typeof currPropValue == "string") {

                                            if (currPropValue.trim().toLowerCase().indexOf(prmFind.trim().toLowerCase()) >= 0) {
                                                //prmObj[currKey] = prmReplace;



                                                var currResultObj = {
                                                    'path': currPath,
                                                    'paramStr': currPropValue
                                                }

                                                outArr.push(currResultObj);

                                            }
                                        }
                                    }
                                    else {

                                        var currPath = refParentPath;
                                        if (!!currPath) {

                                            currPath += '.';
                                        }
                                        currPath += currKey;

                                        var currResultsArr = dataUtils.getPathInObjectForValue(currPropValue, prmFind, prmArrIgnoredPath, currPath);

                                        if (!!currResultsArr && currResultsArr.length > 0) {

                                            outArr = outArr.concat(currResultsArr);
                                        }

                                    }
                                }
                            }
                            else {
                                //        var a = 1;
                            }
                        }
                    }
                }


            }
        }

        return outArr;
    },

    getMaxValue: function (prmArr, prmPropertyName) {
        let outVal = Number.MAX_SAFE_INTEGER;

        if (!!prmArr && Array.isArray(prmArr)) {
            const lstMappedData = prmArr.map((prmItem) => prmItem[prmPropertyName])
            outVal = Math.max(lstMappedData)
        }

        return outVal;
    },

    getMinValue: function (prmArr, prmPropertyName) {
        let outVal = Number.MIN_SAFE_INTEGER;

        if (!!prmArr && Array.isArray(prmArr)) {
            const lstMappedData = prmArr.map((prmItem) => prmItem[prmPropertyName])
            outVal = Math.min(lstMappedData)
        }

        return outVal;
    },

    getMaxDate: function (prmArr, prmPropertyName) {
        let outVal =  new Date();

        if (!!prmArr && Array.isArray(prmArr)) {
            const lstMappedData = prmArr.map((prmItem) => prmItem[prmPropertyName])
            outVal = new Date(Math.max.apply(null,lstMappedData)) //Math.max(lstMappedData)
        }

        return outVal;
    },

    getMinDate: function (prmArr, prmPropertyName) {
        let outVal = new Date();

        if (!!prmArr && Array.isArray(prmArr)) {
            const lstMappedData = prmArr.map((prmItem) => prmItem[prmPropertyName])
            outVal = new Date(Math.min.apply(null,lstMappedData))
        }

        return outVal;
    },

    isNativeProperty: function (prmProperty) {
        var outVal = false;

        if (typeof prmProperty == "string"
            || typeof prmProperty == "number"
            || typeof prmProperty == "boolean"
            || prmProperty instanceof Date) {

            outVal = true;
        }

        return outVal;
    },

    isObjectsEquals: function (prmObj1,prmObj2) {
        let outVal = (JSON.stringify(prmObj1) == JSON.stringify(prmObj2))

        return outVal;
    },

    mergeArrays: function (prmArrMasterData,prmArrSecondaryData,prmRelFieldName) {
        let lstOut = prmArrMasterData

        if (!!prmArrMasterData && !!prmArrSecondaryData){
            const dicSecondaryData = dataUtils.convertArrayToDicObject(prmArrSecondaryData, prmRelFieldName);

            lstOut = prmArrMasterData.map((prmItem) => {
                let outObj = prmItem
                let currKey =  prmItem[prmRelFieldName]

                if (!!dicSecondaryData[currKey]){
                    outObj = dicSecondaryData[currKey]
                    dicSecondaryData[currKey].isMatched = true
                }

                return outObj
            })

            let lstNewRowsFromSecondary = prmArrSecondaryData.filter((prmItem) => {
                return !prmItem.isMatched
            })

            for (const newRowObj of lstNewRowsFromSecondary) {
                lstOut.push(newRowObj)
            }
        }

        return lstOut
    },

    copyOnlySpecificFieldsInObj: function (prmSourceObj, prmTargetObj, prmArrFieldsToCopy) {

        for (var currField in prmSourceObj) {

            if (prmArrFieldsToCopy.indexOf(currField) > -1) {

                prmTargetObj[currField] = cloneDeep(prmSourceObj[currField]);
            }
        }
    }


};
